import { PROFILE_LOAD_SUCCESS, PROFILE_UNLOAD_SUCCESS } from "./constants";

const initialState = {
  profileId: undefined,
  roles: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PROFILE_LOAD_SUCCESS:
      let profile = action.payload.profile;
      let roles = profile.roles === undefined ? [] : profile.roles;
      return {
        ...state,
        profileId: profile.profileId,
        identity: profile.identity,
        roles: roles
      };

    case PROFILE_UNLOAD_SUCCESS:
      return {
        ...state,
        profileId: undefined,
        identity: undefined,
        roles: []
      }

    default:
      return state;
  }
}